/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CommunityRestService } from '@gh/builder-shared-data';
import { EntityInputDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { Community } from './community.model';

@Injectable()
export class CommunityListBusinessService implements InitViewService,
                                                     InitDialogViewService<EntityInputDialogConfig<Community>> {
  constructor(private communityRest: CommunityRestService) {

  }

  initView(): any {
    return {
      communities: this.findAll(true),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<Community>>): any {
    return route.input.id ? this.get(route.input.id) : this.prepareForCreate();
  }

  prepareForCreate(): Community {
    return {
      id: '',
      name: '',
    };
  }

  create(community: Community): Observable<Community> {
    return this.communityRest.create(community);
  }

  update(community: Community): Observable<Community> {
    return this.communityRest.update(community);
  }

  toggleStatus(community: Community): Observable<Community> {
    return this.update({ ...community, active: !community.active });
  }

  get(id: ID): Observable<Community> {
    return this.communityRest.get(id);
  }

  findAll(onlyActive: boolean): Observable<Community[]> {
    return this.communityRest.findAll({ onlyActive });
  }
}
